import { cn, toneBorder, toneText, type Tone } from '../cn';

export interface TagProps {
  children: React.ReactNode;
  tone?: Tone;
  className?: string;
  /** Live badge variant: 10px and 5/7 padding. */
  large?: boolean;
}

/** Bordered mono tag (design `tag()`): 500 9px/1, .08em, 4/6 padding, radius 4, 1 px border in its own colour. */
export function Tag({ children, tone = 'fg4', className, large }: TagProps) {
  return (
    <span
      className={cn(
        'flex-none whitespace-nowrap rounded-sm border font-mono font-medium uppercase leading-none tracking-micro',
        large ? 'px-[7px] py-[5px] text-xs' : 'px-1.5 py-1 text-2xs',
        toneText[tone],
        toneBorder[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

export const severityTone = (sev: 'info' | 'warn' | 'crit'): Tone => (sev === 'crit' ? 'bad' : sev === 'warn' ? 'warn' : 'fg3');
